import { useEffect, useState, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [tries, setTries] = useState(0);

  const poll = useCallback(async () => {
    if (!sessionId) { setStatus("failed"); return; }
    try {
      const { data } = await api.get(`/payments/status/${sessionId}`);
      if (data.payment_status === "paid") { setStatus("paid"); return; }
      if (["expired", "failed"].includes(data.payment_status)) { setStatus("failed"); return; }
      if (tries >= 8) { setStatus("failed"); return; }
      setTimeout(() => setTries((t) => t + 1), 2000);
    } catch { setTimeout(() => setTries((t) => t + 1), 2000); }
  }, [sessionId, tries]);

  useEffect(() => { poll(); }, [poll]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12" data-testid="payment-success-page">
      <div className="w-full max-w-md glass rounded-2xl p-8 text-center">
        {status === "checking" && (<><Loader2 className="h-14 w-14 text-gold mx-auto animate-spin" /><h1 className="font-display text-2xl font-bold text-white mt-4">Confirming your payment…</h1><p className="text-slate-400 mt-2 text-sm">One moment, we're verifying the transaction.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="h-16 w-16 text-emerald-400 mx-auto" /><h1 className="font-display text-2xl font-bold text-white mt-4">Payment successful!</h1><p className="text-slate-300 mt-2">You now have access to the course. Download the material and schedule your exam.</p><Button className="btn-gold mt-6 w-full" onClick={() => nav("/account")} data-testid="payment-goto-account">Go to my account</Button></>)}
        {status === "failed" && (<><XCircle className="h-16 w-16 text-rose-400 mx-auto" /><h1 className="font-display text-2xl font-bold text-white mt-4">Payment could not be confirmed</h1><p className="text-slate-400 mt-2 text-sm">If you were charged, contact us. You can try again anytime.</p><Button variant="outline" className="mt-6 w-full border-white/20 text-white hover:bg-white/10 bg-transparent" onClick={() => nav("/courses")}>Back to courses</Button></>)}
      </div>
    </div>
  );
}
